import React, { useState, createContext, useContext, useEffect } from "react";
import {
  signInWithPopup,
  GoogleAuthProvider,
  updateProfile,
  signInWithPhoneNumber,
  RecaptchaVerifier,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  FacebookAuthProvider,
  sendEmailVerification,
  signInAnonymously,
} from "firebase/auth";
import { authentication } from "../store/firebase-config";
import firebase from "firebase/app";
import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import axios from "axios";
import { isEmpty } from "lodash";

const userAuthContext = createContext();

export function UserAuthContextProvider({ children }) {
  //otp variable
  const [emailError, setEmailError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpResult, setOtpResult] = useState("");
  const [otpShow, setOtpShow] = useState(false);
  const [verifiedDeletion, setVerifiedDeletion] = useState(false);
  const [numberVerificationLoading, setNumberVerificationLoading] =
    useState(false);
  const [otpVerificationLoading, setOtpVerificationLoading] = useState(false);
  const [urlPath, setUrlPath] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(false);
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState();
  const [previousLocation, setPreviousLocation] = useState();
  const [guestModeEnabled, setGuestModeEnabled] = useState(true);
  const previousLocationFromUrl = urlPath.split("/")[4];
  const organizerName = window.location.href
    .split("/")[3]
    ?.replace(/\.html$/, "");
  const contestName = window.location.pathname
    .split("/")[3]
    ?.replace(/\.html$/, "");
  const campaignName = window.location.pathname
    .split("/")[2]
    ?.replace(/\.html$/, "");
  const verifyOrganizerFromUrl = window.location.pathname.split("/")[1];
  const [changesPresent, setChangesPresent] = useState(false);
  const [newUserId, setNewUserId] = useState("");
  const [retryCreateUser, setRetryCreateUser] = useState(false);
  const [retryUpdateName, setRetryUpdateName] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [reqForGenerate, setReqForGenerate] = useState(false);
  const [reqForLeadsSubmit, setReqLeadsSubmit] = useState(false);
  const [verificationPopup, setVerificationPopup] = useState(false);
  const [whatsappVerified, setWhatsappVerified] = useState();
  const [emailVerified, setEmailVerified] = useState();
  const [emailPopup, setEmailPopup] = useState(false);
  const [emailAccountCreated, setEmailAccountCreated] = useState(false);
  const [userDetailsFromApi, setUserDetailsFromApi] = useState();
  const [numberVerificationError, setNumberVerificationError] = useState();
  const [wpNumberVerificationLoading, setWpNumberVerificationLoading] =
    useState();
  const [enterUserDisplayName, setEnterUserDisplayName] = useState({
    display: false,
  });
  const [namePatchLoading, setNamePatchLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const preview = searchParams.get("preview");
  const buildType = process.env.REACT_APP_BUILD_TYPE;

  const location = useLocation();
  useEffect(() => {
    setUrlPath(window.location.href);
    // eslint-disable-next-line
  }, []);
  const userId = localStorage.getItem("userId");

  const loginChecker = async (accessToken) => {
    let config1 = {
      method: "post",
      url: `${process.env.REACT_APP_CREATE_USERS}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      data: {
        platformType: buildType == "highonevent" ? "HOE" : "",
      },
    };
    const loginCheck = await axios(config1);
    setNewUserId(loginCheck.data?.userId);
    setUserDetailsFromApi(loginCheck.data);
    setWhatsappVerified(loginCheck.data?.phoneNumberVerified);
    setEmailVerified(loginCheck.data?.emailVerified);
    localStorage.setItem("userId", loginCheck.data?.userId);
  };
  useEffect(() => {
    const unsubscribe = authentication.onAuthStateChanged((user) => {
      setCurrentUser(user);
      // setEmailVerified(user?.emailVerified);
      const userIdFromLocal = localStorage.getItem("userId");

      if (!isEmpty(user)) {
        setGuestModeEnabled(false);
        if (isEmpty(userIdFromLocal) || userIdFromLocal == "") {
          loginChecker(user.accessToken);
        } else if (whatsappVerified == null || whatsappVerified == undefined) {
          loginChecker(user.accessToken);
        }
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const guestUserSignin = () => {
    setGuestModeEnabled(true);
    if (previousLocationFromUrl === "signup") {
      if (preview) {
        window.location.href = `/${organizerName}/${campaignName}?preview=true`;
      } else {
        window.location.href = `/${organizerName}/${campaignName}`;
      }
    } else {
      if (previousLocation == null) {
        setPageLoading(false);
        window.location.href = urlPath;
      } else {
        setPageLoading(false);
        window.location.href = previousLocation;
      }
    }
  };
  const googleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      setPageLoading(true);
      const login = await signInWithPopup(authentication, provider);
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_CREATE_USERS}`,
        headers: {
          Authorization: `Bearer ${login._tokenResponse.idToken}`,
          "Content-Type": "application/json",
        },
        data: {
          platformType: buildType == "highonevent" ? "HOE" : "",
        },
      };
      const loginCheck = await axios(config);
      const campaignUniqueText = localStorage.getItem("campaignUniqueText");
      if (loginCheck.status === 201) {
        localStorage.setItem("userId", loginCheck.data?.userId);
        setNewUserId(loginCheck.data?.userId);
        setGuestModeEnabled(false);
        if (location?.state?.previousLocation) {
          navigate(
            {
              pathname: location?.state?.previousLocation,
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        } else {
          navigate(
            {
              pathname: "/",
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        }
        setPageLoading(false);
      } else {
        setPageLoading(false);
        let error = {
          type: "createUser_from_app",
          email: login?.user.email,
          msg: loginCheck?.data?.message,
          token: login?._tokenResponse?.idToken,
        };
        setErrorData(error);
        setRetryCreateUser(true);
      }
    } catch (error) {
      setPageLoading(false);
      navigate(`/signup`, {
        state: location?.state,
      });
    }
  };
  const faceBookSignIn = async () => {
    try {
      const provider = new FacebookAuthProvider();
      setPageLoading(true);
      const login = await signInWithPopup(authentication, provider);
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_CREATE_USERS}`,
        headers: {
          Authorization: `Bearer ${login._tokenResponse.idToken}`,
          "Content-Type": "application/json",
        },
        data: {
          platformType: buildType == "highonevent" ? "HOE" : "",
        },
      };
      const loginCheck = await axios(config);
      if (loginCheck.status === 201) {
        localStorage.setItem("userId", loginCheck.data?.userId);
        setNewUserId(loginCheck.data?.userId);
        setGuestModeEnabled(false);
        if (location?.state?.previousLocation) {
          navigate(
            {
              pathname: location?.state?.previousLocation,
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        } else {
          navigate(
            {
              pathname: "/",
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        }
        setPageLoading(false);
      } else {
        setPageLoading(false);
        let error = {
          type: "createUser_from_app",
          email: login?.user.email,
          msg: loginCheck?.data?.message,
          token: login?._tokenResponse?.idToken,
        };
        setErrorData(error);
        setRetryCreateUser(true);
      }
    } catch (error) {
      setPageLoading(false);
      navigate(`/signup`, {
        state: location?.state,
      });
    }
  };
  // second step
  let cancelTokenSource = null;

  const updateUserssProfile = async (
    data,
    editedDetails,
    photoUrl,
    setEditProfile
  ) => {
    try {
      const updateUserProfile = await updateProfile(currentUser, {
        displayName: data?.name,
        photoURL: photoUrl,
        phoneNumber: data?.phone,
      });
      if (cancelTokenSource !== null) {
        cancelTokenSource.cancel("Request canceled due to button click.");
      }

      // Create a new cancel token source

      cancelTokenSource = axios.CancelToken.source();
      let config = {
        method: "PATCH",
        url: `${process.env.REACT_APP_UPDATE_PROFILE_DETAILS}`,
        headers: {
          Authorization: `Bearer ${currentUser.accessToken}`,
          "Content-Type": "application/json",
        },
        cancelToken: cancelTokenSource.token,
        data: editedDetails,
      };
      const updateProfileDetails = await axios(config);
      setChangesPresent(false);
      // setEditProfile(false);
    } catch (error) {
      console.log("error", error);
    }
  };
  //email signin
  const emailSignIn = async (name, email, password) => {
    try {
      setPageLoading(true);
      const response = await createUserWithEmailAndPassword(
        authentication,
        email,
        password
      );
      const updateUserProfile = await updateProfile(response?.user, {
        displayName: name,
      });
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_CREATE_USERS}`,
        headers: {
          Authorization: `Bearer ${response._tokenResponse.idToken}`,
          "Content-Type": "application/json",
        },
        data: { name, platformType: buildType == "highonevent" ? "HOE" : "" },
      };
      const loginCheck = await axios(config);
      if (loginCheck.status === 201) {
        localStorage.setItem("userId", loginCheck.data?.userId);
        setNewUserId(loginCheck.data?.userId);
        setGuestModeEnabled(false);
        setEmailAccountCreated(true);
        if (location?.state?.previousLocation) {
          navigate(
            {
              pathname: location?.state?.previousLocation,
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        } else if (organizerName && campaignName) {
          navigate(
            {
              pathname: `/${organizerName}/${campaignName}`,
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        } else {
          navigate(
            {
              pathname: "/",
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        }
        setPageLoading(false);

        // emailVerification(response?.user);
        setTimeout(() => {
          emailVerificationGoviral(email, response._tokenResponse.idToken);
        }, 1500);
      }
    } catch (error) {
      setPageLoading(false);
      const cleanedErrorMessage = error?.message?.match(/auth\/(.+?)\)/);
      if (cleanedErrorMessage && cleanedErrorMessage[1]) {
        const errorCode = cleanedErrorMessage[1];
        setEmailError(errorCode);
      } else {
        const cleanedErrorMessage = error?.message?.replace(
          /^Firebase:\s*/,
          ""
        );
        setEmailError(cleanedErrorMessage);
      }
      console.log("error", error);
    }
  };
  //email login
  const emailLogin = async (email, password) => {
    try {
      setPageLoading(true);
      const response = await signInWithEmailAndPassword(
        authentication,
        email,
        password
      );

      let config = {
        method: "post",
        url: `${process.env.REACT_APP_CREATE_USERS}`,
        headers: {
          Authorization: `Bearer ${response._tokenResponse.idToken}`,
          "Content-Type": "application/json",
        },
        data: {
          platformType: buildType == "highonevent" ? "HOE" : "",
        },
      };
      const loginCheck = await axios(config);
      if (loginCheck.status === 201) {
        localStorage.setItem("userId", loginCheck.data?.userId);
        setNewUserId(loginCheck.data?.userId);
        setGuestModeEnabled(false);
        if (location?.state?.previousLocation) {
          navigate(
            {
              pathname: location?.state?.previousLocation,
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        } else if (organizerName && campaignName) {
          navigate(
            {
              pathname: `/${organizerName}/${campaignName}`,
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        } else {
          navigate(
            {
              pathname: "/",
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        }
        setPageLoading(false);
      }
    } catch (error) {
      setPageLoading(false);
      const cleanedErrorMessage = error?.message?.match(/auth\/(.+?)\)/);
      if (cleanedErrorMessage && cleanedErrorMessage[1]) {
        const errorCode = cleanedErrorMessage[1];
        setEmailError(errorCode);
      } else {
        const cleanedErrorMessage = error?.message?.replace(
          /^Firebase:\s*/,
          ""
        );
        setEmailError(cleanedErrorMessage);
      }

      console.log("error", error);
    }
  };

  //email login password reset
  const emailPasswordReset = async (email) => {
    try {
      setPageLoading(true);
      const response = await sendPasswordResetEmail(authentication, email);
      setPageLoading(false);
      return true;
    } catch (error) {
      setPageLoading(false);
      const cleanedErrorMessage = error?.message?.match(/auth\/(.+?)\)/);
      if (cleanedErrorMessage && cleanedErrorMessage[1]) {
        const errorCode = cleanedErrorMessage[1];
        setEmailError(errorCode);
      } else {
        const cleanedErrorMessage = error?.message?.replace(
          /^Firebase:\s*/,
          ""
        );
        setEmailError(cleanedErrorMessage);
      }

      console.log("error", error);
    }
  };
  //otp signin

  const otpSignIn = async (number) => {
    try {
      if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new RecaptchaVerifier(
          "recaptcha-container",
          { size: "invisible" },
          authentication
        );
        window.recaptchaVerifier.render();
      }
      const otpData = await signInWithPhoneNumber(
        authentication,
        number,
        window.recaptchaVerifier
      );

      return otpData;
    } catch (error) {
      const cleanedErrorMessage = error?.message?.replace(/^Firebase:\s*/, "");
      setOtpError(cleanedErrorMessage);
      console.log("error", error);
    }
  };

  //Send OTP
  const sendOtp = async (phoneNumber) => {
    setNumberVerificationLoading(true);
    setOtpError("");
    if (phoneNumber === "" || phoneNumber === undefined)
      return setOtpError("Please enter a valid phone number!");
    try {
      const response = await otpSignIn(phoneNumber);
      setNumberVerificationLoading(false);
      if (response) {
        setOtpResult(response);
        setOtpShow(true);
      }
    } catch (err) {
      const cleanedErrorMessage = err?.message?.replace(/^Firebase:\s*/, "");
      setOtpError(cleanedErrorMessage);
    }
  };

  // Resend OTP
  const resendOtp = async (phoneNumber) => {
    signInWithPhoneNumber(
      authentication,
      phoneNumber,
      window.recaptchaVerifier
    );
  };

  //Verify Otp
  const verifyOtp = async (result, otp) => {
    setOtpError("");
    setOtpVerificationLoading(true);
    if (otp === "" || otp === null) return;
    try {
      const otpResponse = await result.confirm(otp);
      if (otpResponse?.user) {
        userCheck(otpResponse);
      }
      setOtpVerificationLoading(false);
    } catch (err) {
      console.log(err);
      const cleanedErrorMessage = err?.message?.replace(/^Firebase:\s*/, "");
      setOtpError(cleanedErrorMessage);
      setOtpVerificationLoading(false);
    }
  };
  const userCheck = async (otpResponse) => {
    setNamePatchLoading(true);
    setOtpError("");
    try {
      let config1 = {
        method: "post",
        url: `${process.env.REACT_APP_CREATE_USERS}`,
        headers: {
          Authorization: `Bearer ${otpResponse?._tokenResponse?.idToken}`,
          "Content-Type": "application/json",
        },
        data: {
          platformType: buildType == "highonevent" ? "HOE" : "",
        },
      };
      const loginCheck = await axios(config1);

      if (loginCheck?.status === 201) {
        localStorage.setItem("userId", loginCheck?.data?.userId);
        setNewUserId(loginCheck?.data?.userId);
        if (!loginCheck?.data?.name) {
          setEnterUserDisplayName({
            display: true,
            otpResponse: otpResponse,
          });

          setNamePatchLoading(false);
        } else {
          window.recaptchaVerifier = null;
          setGuestModeEnabled(false);
          setNamePatchLoading(false);
          setOtpShow(false);
          setEnterUserDisplayName({
            display: false,
          });
          if (location?.state?.previousLocation) {
            navigate(
              {
                pathname: location?.state?.previousLocation,
                search: `${
                  searchParams ? createSearchParams(searchParams) : ""
                }`,
              },
              { state: location?.state }
            );
          } else {
            navigate(
              {
                pathname: "/",
                search: `${
                  searchParams ? createSearchParams(searchParams) : ""
                }`,
              },
              { state: location?.state }
            );
          }
        }
      } else {
        let error = {
          type: "createUser_from_app",
          phoneNumber: otpResponse?.user.phoneNumber,
          msg: loginCheck?.data?.message,
          token: otpResponse?._tokenResponse?.idToken,
        };
        setErrorData(error);
        setRetryCreateUser(true);
      }
    } catch (err) {
      setOtpError(err.message);
      setNamePatchLoading(false);
    }
  };
  const patchDisplayNameAndCreateUser = async (otpResponse, useDetails) => {
    setNamePatchLoading(true);
    try {
      let config2 = {
        method: "PATCH",
        url: `${process.env.REACT_APP_UPDATE_PROFILE_DETAILS}`,
        headers: {
          Authorization: `Bearer ${otpResponse?._tokenResponse?.idToken}`,
          "Content-Type": "application/json",
        },
        data: useDetails,
      };
      // updateFirebaseName(useDetails?.name);
      const updateUserProfile = updateProfile(currentUser, {
        displayName: useDetails?.name,
      });

      window.recaptchaVerifier = null;

      const updateProfileDetails = await axios(config2);
      if (updateProfileDetails?.status === 200) {
        window.recaptchaVerifier = null;
        setGuestModeEnabled(false);
        setNamePatchLoading(false);
        setOtpShow(false);
        setEnterUserDisplayName({
          display: false,
        });
        if (location?.state?.previousLocation) {
          navigate(
            {
              pathname: location?.state?.previousLocation,
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        } else {
          navigate(
            {
              pathname: "/",
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        }
        setOtpVerificationLoading(false);
      } else {
        let error = {
          type: "updateName_from_app",
          phoneNumber: otpResponse?.user.phoneNumber,
          msg: updateProfileDetails?.data?.message,
          token: otpResponse?._tokenResponse?.idToken,
        };
        setErrorData(error);
        setRetryUpdateName(true);
      }
    } catch (err) {
      setOtpError(err.message);
      setNamePatchLoading(false);
      window.recaptchaVerifier = null;
      setGuestModeEnabled(false);
      setNamePatchLoading(false);
      setOtpShow(false);
      setEnterUserDisplayName({
        display: false,
      });
      navigate(
        {
          pathname: location?.state?.previousLocation,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        },
        { state: location?.state }
      );
      setOtpVerificationLoading(false);
    }
  };

  const verifyWpOtp = async (otp) => {
    setNumberVerificationError("");
    setWpNumberVerificationLoading(true);
    let trimmedOtp = otp?.replace(/\s/g, "");
    if (trimmedOtp === "" || trimmedOtp === null) return;
    try {
      let config = {
        method: "patch",
        url: `${process.env.REACT_APP_VERIFY_WP_OTP}`,
        headers: {
          Authorization: `Bearer ${currentUser?.accessToken}`,
          "Content-Type": "application/json",
        },
        data: { otp: trimmedOtp },
      };
      const otpResponse = await axios(config);
      if (otpResponse?.data?.status == "success") {
        if (otpResponse?.data?.verified) {
          setVerificationPopup(false);
          setWhatsappVerified(true);
        } else {
          setNumberVerificationError(otpResponse?.data?.msg);
        }
      }
      setWpNumberVerificationLoading(false);
    } catch (err) {
      console.log(err);
      setNumberVerificationError();
      setWpNumberVerificationLoading(false);
    }
  };

  //email login password reset
  const emailVerification = async (user) => {
    try {
      setPageLoading(true);
      const response = await sendEmailVerification(user);

      return true;
    } catch (error) {
      setPageLoading(false);
      const cleanedErrorMessage = error?.message?.match(/auth\/(.+?)\)/);
      if (cleanedErrorMessage && cleanedErrorMessage[1]) {
        const errorCode = cleanedErrorMessage[1];
        setEmailError(errorCode);
      } else {
        const cleanedErrorMessage = error?.message?.replace(
          /^Firebase:\s*/,
          ""
        );
        setEmailError(cleanedErrorMessage);
      }
      console.log("error", error);
    }
  };

  const emailVerificationGoviral = async (email, accessToken) => {
    try {
      setPageLoading(true);
      let config = {
        method: "PATCH",
        url: `https://us-central1-tripsmagic.cloudfunctions.net/goviralUsers/api/goviral/users/generate_otp_with_mail`,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        data: {
          email,
        },
      };
      const response = await axios(config);
      setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
      console.log("error", error);
    }
  };
  const verifyEmailOtp = async (otp) => {
    setPageLoading(true);
    if (otp === "" || otp === null) return;
    try {
      let config = {
        method: "PATCH",
        url: `https://us-central1-tripsmagic.cloudfunctions.net/goviralUsers/api/goviral/users/verify_email_otp`,
        headers: {
          Authorization: `Bearer ${currentUser?.accessToken}`,
          "Content-Type": "application/json",
        },
        data: {
          otp,
        },
      };
      const response = await axios(config);
      if (response?.data?.status == "success") {
        setEmailVerified(true);
      } else {
        setEmailError(response?.data?.msg);
      }
      setPageLoading(false);
    } catch (err) {
      console.log(err);
      setPageLoading(false);
    }
  };

  //Anonymous login
  const anonymousLogin = async (name, uniqueId) => {
    try {
      setPageLoading(true);
      const response = await signInAnonymously(authentication);

      let config = {
        method: "post",
        url: `${process.env.REACT_APP_CREATE_USERS}`,
        headers: {
          Authorization: `Bearer ${response._tokenResponse.idToken}`,
          "Content-Type": "application/json",
        },
        data: {
          platformType: buildType == "highonevent" ? "HOE" : "",
          uniqueId,
          name,
        },
      };
      const loginCheck = await axios(config);
      if (loginCheck.status === 201) {
        localStorage.setItem("userId", loginCheck.data?.userId);
        setNewUserId(loginCheck.data?.userId);
        setGuestModeEnabled(false);
        if (uniqueId || name) {
          await patchDisplayNameAndCreateUser(response, { uniqueId, name });
        }
        if (location?.state?.previousLocation) {
          navigate(
            {
              pathname: location?.state?.previousLocation,
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        } else if (organizerName && campaignName) {
          navigate(
            {
              pathname: `/${organizerName}/${campaignName}`,
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        } else {
          navigate(
            {
              pathname: "/",
              search: `${searchParams ? createSearchParams(searchParams) : ""}`,
            },
            { state: location?.state }
          );
        }
        setPageLoading(false);
      }
    } catch (error) {
      setPageLoading(false);
      const cleanedErrorMessage = error?.message?.match(/auth\/(.+?)\)/);
      if (cleanedErrorMessage && cleanedErrorMessage[1]) {
        const errorCode = cleanedErrorMessage[1];
        setEmailError(errorCode);
      } else {
        const cleanedErrorMessage = error?.message?.replace(
          /^Firebase:\s*/,
          ""
        );
        setEmailError(cleanedErrorMessage);
      }

      console.log("error", error);
    }
  };
  const fetchUserData = async () => {
    try {
      const user = authentication.currentUser;
      await user.reload();
      setCurrentUser(user);
      // setEmailVerified(user?.emailVerified);
      return user;
    } catch (error) {
      console.error("Error reloading user data", error);
      // Handle error here
    }
  };
  return (
    <userAuthContext.Provider
      value={{
        guestUserSignin,
        anonymousLogin,
        setCurrentUser,
        googleSignIn,
        updateUserssProfile,
        currentUser,
        pageLoading,
        setPageLoading,
        setPreviousLocation,
        previousLocation,
        loading,
        otpSignIn,
        verifyOtp,
        otpError,
        setOtpError,
        otpResult,
        setOtpResult,
        sendOtp,
        otpShow,
        setOtpShow,
        numberVerificationLoading,
        otpVerificationLoading,
        enterUserDisplayName,
        setEnterUserDisplayName,
        patchDisplayNameAndCreateUser,
        namePatchLoading,
        urlPath,
        resendOtp,
        guestModeEnabled,
        setGuestModeEnabled,
        userId,
        changesPresent,
        setChangesPresent,
        newUserId,
        setNewUserId,
        searchParams,
        setSearchParams,
        newUserId,
        loginChecker,
        retryCreateUser,
        setRetryCreateUser,
        userCheck,
        errorData,
        reqForGenerate,
        setReqForGenerate,
        reqForLeadsSubmit,
        setReqLeadsSubmit,
        whatsappVerified,
        setWhatsappVerified,
        userDetailsFromApi,
        wpNumberVerificationLoading,
        setWpNumberVerificationLoading,
        numberVerificationError,
        setNumberVerificationError,
        verifyWpOtp,
        verificationPopup,
        setVerificationPopup,
        verifyWpOtp,
        emailSignIn,
        emailError,
        setEmailError,
        emailLogin,
        emailPasswordReset,
        faceBookSignIn,
        emailVerified,
        setEmailVerified,
        verifyEmailOtp,
        emailPopup,
        setEmailPopup,
        emailVerification,
        emailVerificationGoviral,
        fetchUserData,
        emailAccountCreated,
        setEmailAccountCreated,
        verifiedDeletion,
        setVerifiedDeletion,
      }}
    >
      {!loading && children}
    </userAuthContext.Provider>
  );
}

export function useUserAuth() {
  return useContext(userAuthContext);
}
